orders-planner-show-all-phases
  .btn.btn-collapse.btn-outline-success.btn-sm.btn-collapse(if="{!this.show}" onClick="{onClickOpenButton}")
    span.feather.icon-toggle-right
  .btn.btn-collapse.btn-success.btn-sm.btn-collapse(if="{ this.show}" onClick="{onClickCloseButton}")
    span.feather.icon-toggle-left
  script(type="typescript").
    this.mixin('orders.planner.show-all-phases');
  style(scoped).
    :scope {
      display: inline-block;
    }
    .tags-wrap {
      margin-right: 60px;
    }
    .tags-wrap .label {
      display: inline-block;
      padding: 7px 7px;
      margin-bottom: 1px;
    }
    .btn-collapse {
      /* position: absolute;
      right: 15px;
      top: 0; */
    }
